export default "__VITE_ASSET__Cx2XB7_q__"